const l = "_header_1bzld_1", _ = "_title_1bzld_8", t = "_main_1bzld_15", o = "_mainOverFlow_1bzld_20", e = "_footer_1bzld_25", a = "_content_1bzld_32", d = "_actions_1bzld_80", n = "_dialogOverlay_1bzld_91", i = "_dialog_1bzld_91", s = "_small_1bzld_124", c = "_wide_1bzld_133", r = {
  header: l,
  title: _,
  main: t,
  mainOverFlow: o,
  footer: e,
  content: a,
  actions: d,
  dialogOverlay: n,
  dialog: i,
  small: s,
  wide: c,
  default: "_default_1bzld_142"
};
export {
  d as actions,
  a as content,
  r as default,
  i as dialog,
  n as dialogOverlay,
  e as footer,
  l as header,
  t as main,
  o as mainOverFlow,
  s as small,
  _ as title,
  c as wide
};
//# sourceMappingURL=Modal.module.css.js.map
